<template>
  <b-container>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="sm"
      @hide="cancel()"
      :title="$t('geral.importLayout')"
    >
      <b-form-group label="Etapas">
        <b-form-checkbox-group
          id="checkbox-group-1"
          v-model="stageSelected"
          :options="stageOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>

      <!-- {{ processId }} -->
      <!-- {{ stageOptions }} -->
      <!-- {{ stageSelected }} -->
      <template #modal-footer="{}">
        <div class="right">
          <b-button
            variant="green"
            @click="downloadLayout"
            :disabled="submitted"
          >
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "WorkflowImportLayoutModal",
  props: {
    processId: String,
  },
  components: {},
  data() {
    return {
      submitted: false,
      stageOptions: [],
      stageSelected: [],
    };
  },
  methods: {
    show() {
      this.$refs.openModal.show();
      this.getAllStageOptions();
    },
    cancel() {
      this.stageSelected = [];
      this.$refs.openModal.hide();
    },
    getAllStageOptions() {
      this.$apiWorkflow
        .get(`/stage/allStage/${this.processId}`)
        .then((response) => {
          // console.log(response.data);
          this.stageOptions = response.data;
        });
    },
    downloadLayout() {
      this.$apiWorkflow
        .request({
          url: `/import/DownloadLayout/${this.processId}`,
          method: "POST",
          data: this.stageSelected,
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.$refs.openModal.hide();
        });
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>